import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning\"><path d=\"M512.53333333 36.26133333c-262.92266667 0-476.064 213.14133333-476.064 476.064S249.61066667 988.3872 512.53333333 988.3872s476.064-213.14026667 476.064-476.06293333S775.456 36.26133333 512.53333333 36.26133333zM585.6 853.33333333H434.13333333V680.53333333h151.46666667v172.8z m0-265.6H434.13333333V171.73333333h151.46666667v416z\" p-id=\"23111\" fill=\"#ea9518\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol